import React from 'react';
import { Link } from 'react-router-dom';
import PublicNav from './PublicNav';

const C = {
  ink: '#344767',
  muted: '#8392ab',
  primary: '#5e72e4',
  border: '#e9ecef',
  bgSoft: '#f8f9fe',
  shadow: '0 2px 24px rgba(52,71,103,0.09)',
};

const features = [
  {
    icon: 'fas fa-bullseye',
    title: 'Lead capture & assignment',
    text: 'Import from Excel, Facebook Lead Ads, and manual entry — route leads to the right agent instantly.',
  },
  {
    icon: 'fas fa-tasks',
    title: 'Follow-ups & pipeline',
    text: 'Pending follow-ups, Kanban stages, and notifications so nothing falls through the cracks.',
  },
  {
    icon: 'fas fa-building',
    title: 'Property & inventory',
    text: 'List projects, units, and bookings with a clear view for sales and management.',
  },
  {
    icon: 'fas fa-user-shield',
    title: 'Multi-tenant & roles',
    text: 'Super Admin, Admin, and Employee roles with client-scoped data and subscription controls.',
  },
  {
    icon: 'fab fa-facebook',
    title: 'Meta Lead Ads',
    text: 'One webhook URL — tenants resolved by Page ID; scheduler backup polling for reliability.',
  },
  {
    icon: 'fas fa-chart-bar',
    title: 'Reporting',
    text: 'Dashboards and filtered reports for leads, assignments, and team activity.',
  },
];

export default function ProductLanding() {
  return (
    <div style={{ minHeight: '100vh', background: C.bgSoft, fontFamily: 'inherit', color: C.ink }}>
      <PublicNav />

      <section
        style={{
          background: 'linear-gradient(135deg,#344767 0%,#21243d 100%)',
          padding: '64px 24px 80px',
          textAlign: 'center',
        }}
      >
        <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13, fontWeight: 700, letterSpacing: '0.12em', margin: '0 0 16px' }}>
          REAL ESTATE CRM
        </p>
        <h1 style={{ margin: '0 0 16px', fontSize: 38, fontWeight: 800, color: '#fff', lineHeight: 1.2 }}>
          NextFollowUp — built for agencies &amp; builders
        </h1>
        <p style={{ margin: '0 auto 28px', maxWidth: 560, fontSize: 17, color: 'rgba(255,255,255,0.78)', lineHeight: 1.6 }}>
          One platform for leads, follow-ups, properties, and team productivity — with SaaS-ready tenancy and integrations.
        </p>
        <Link
          to="/contact-sales"
          style={{
            display: 'inline-block',
            padding: '14px 28px',
            borderRadius: 12,
            background: C.primary,
            color: '#fff',
            fontWeight: 700,
            textDecoration: 'none',
            marginRight: 12,
          }}
        >
          Request information
        </Link>
        <Link
          to="/login"
          style={{
            display: 'inline-block',
            padding: '14px 28px',
            borderRadius: 12,
            border: '2px solid rgba(255,255,255,0.35)',
            color: '#fff',
            fontWeight: 700,
            textDecoration: 'none',
          }}
        >
          Sign in to CRM
        </Link>
      </section>

      <div style={{ maxWidth: 1040, margin: '0 auto', padding: '56px 20px 72px' }}>
        <h2 style={{ textAlign: 'center', fontSize: 26, fontWeight: 800, margin: '0 0 12px' }}>Features</h2>
        <p style={{ textAlign: 'center', color: C.muted, margin: '0 0 40px', fontSize: 15 }}>
          Everything your team needs to convert inquiries into closed deals.
        </p>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
            gap: 20,
          }}
        >
          {features.map((f) => (
            <div
              key={f.title}
              style={{
                background: '#fff',
                borderRadius: 16,
                padding: 24,
                boxShadow: C.shadow,
                border: `1px solid ${C.border}`,
              }}
            >
              <div
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: 12,
                  background: `${C.primary}18`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: C.primary,
                  fontSize: 18,
                  marginBottom: 14,
                }}
              >
                <i className={f.icon} aria-hidden />
              </div>
              <h3 style={{ margin: '0 0 8px', fontSize: 17, fontWeight: 700 }}>{f.title}</h3>
              <p style={{ margin: 0, fontSize: 14, color: C.muted, lineHeight: 1.55 }}>{f.text}</p>
            </div>
          ))}
        </div>
      </div>

      <footer style={{ textAlign: 'center', padding: '28px 16px', borderTop: `1px solid ${C.border}`, background: '#fff', color: C.muted, fontSize: 13 }}>
        © {new Date().getFullYear()} NextFollowUp — All rights reserved.
      </footer>
    </div>
  );
}
